export const API = Object.freeze({
  ENV: '/env.json',
  AUTHORIZE_VEEVA_SESSION: 'api/v1/authorize-veeva-session',
  DOCUMENTS: 'documents/document_id/versions/document_version',
  ASSESSMENT:
    'v2/documents/document_id/versions/document_version' +
    '/assessment?ssiDocumentNumbers=[ssiDocumentNumbers]',
  ASSESSMENT_PAGE: 'v2/assessment/[token]/page/[page_number]',
  ASSESSMENT_SUMMARY: 'v2/assessment/[token]/summary',
  ASSESSMENT_REPORT: 'v2/assessment/[token]/reports/[reportType]',
});
